import {IDataLayer} from "../app";

interface Hash<T> {
    [clave: string]: T;
}

interface HashDeCampos extends Hash<Campo> {
}

class Campo {
    input: HTMLInputElement;
    etiqueta: HTMLElement;
    visibilidad: Hash<string>;
    obligatorio: boolean;

    constructor(input: HTMLInputElement, etiqueta: HTMLElement, visibilidad: Hash<string>, obligatorio: boolean) {
        this.input = input;
        this.etiqueta = etiqueta;
        this.visibilidad = visibilidad;
        this.obligatorio = obligatorio;
    }
}

const buscaCampoDeEtiqueta = (etiqueta: HTMLElement): HTMLInputElement | null => {
        const atributoFor = etiqueta.getAttribute('for');
        if (atributoFor) {
            return <HTMLInputElement>document.getElementById(atributoFor);
        }

        return null;
    },
    buscaCampos = (formulario: HTMLFormElement) => {
        const campos: HashDeCampos = {},
            etiquetas: NodeListOf<HTMLElement> =
                formulario.querySelectorAll(`.campo label`);

        [].forEach.call(etiquetas, function (etiqueta: HTMLElement) {
            let input = buscaCampoDeEtiqueta(etiqueta);

            if (input) {
                const padre = <HTMLElement>input.parentNode;

                if (padre) {
                    const campo = new Campo(input,
                        <HTMLElement>etiqueta.cloneNode(true),
                        JSON.parse(padre.getAttribute('data-visibilidad') || '{}'),
                        input.required
                    );
                    campos[input.id] = campo;
                }
            }
        });

        return campos;
    },
    configuraEtiquetas = (formulario: HTMLFormElement) => {
        const campos: HashDeCampos = {},
            etiquetas: NodeListOf<HTMLElement> =
                formulario.querySelectorAll(`.campo:not(.campo--checkbox) > label`);

        [].forEach.call(etiquetas, function (etiqueta: HTMLElement) {
            let input = buscaCampoDeEtiqueta(etiqueta);

            if (input && !input.getAttribute('placeholder')) {
                const padre = <HTMLElement>input.parentNode;

                if (padre) {
                    const campo = new Campo(input,
                        etiqueta,
                        JSON.parse(padre.getAttribute('data-visibilidad') || '{}'),
                        input.required
                    );
                    campos[input.id] = campo;

                    if (campo.input.value?.trim() === '') {
                        etiqueta.classList.add('is-inactiva');
                    }
                }
            }
        });

        formulario.addEventListener('blur', function (e) {
            const input: HTMLInputElement = <HTMLInputElement>e.target,
                campo = campos[input.id];

            if (campo && !campo.input.value?.trim() && !campo.input.classList.contains('con-archivo')) {
                campo.etiqueta.classList.add('is-inactiva');

                if (campo.input.getAttribute('type') === 'date') {
                    campo.input.style.color = 'transparent';
                }
            }
        }, true);

        formulario.addEventListener('focus', function (e) {
            const input: HTMLInputElement = <HTMLInputElement>e.target,
                campo = campos[input.id];

            if (campo) {
                campo.etiqueta.classList.remove('is-inactiva');

                if (campo.input.getAttribute('type') === 'date') {
                    campo.input.style.color = 'currentColor';
                }
            }
        }, true);

        return campos;
    },
    reinicia = (campos: HashDeCampos) => {
        Object.keys(campos).forEach(key => {
            const {input, etiqueta} = campos[key];

            if (!input.value || input.value.trim() === '') {
                etiqueta.classList.add('is-inactiva');

                if (input.getAttribute('type') === 'date') {
                    input.style.color = 'transparent';
                }
            }
        });
    },
    configuraSubmit = (
        formulario: HTMLFormElement,
        opciones: OpcionesFormulario,
    ) => {
        const submit = formulario.querySelector('[type="submit"]') as HTMLButtonElement;

        const enviado = opciones.enviado || (() => {
        });
        const offset = opciones.offset || (() => 0);
        const dataLayer = opciones.dataLayer;

        formulario.addEventListener('submit', e => {
            e.preventDefault();

            submit.disabled = true;

            let promesa = Promise.resolve();
            if (window.recaptcha) {
                promesa = new Promise(resolve => {
                    window.grecaptcha.enterprise.ready(async () => {
                        const token = await window.grecaptcha.enterprise.execute(window.recaptcha!, {action: 'submit'});

                        const input = formulario.querySelector('input[name="g-recaptcha-response"]') || document.createElement('input');
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', 'g-recaptcha-response');
                        input.setAttribute('value', token);
                        formulario.appendChild(input);

                        resolve();
                    });
                });
            }

            promesa.then(() => {
                fetch(formulario.getAttribute('action') || location.href, {
                    method: 'post',
                    body: new FormData(formulario)
                })
                    .then(x => {
                        if (x.redirected) {
                            enviado(formulario);

                            dataLayer?.push({
                                event: 'formulario-enviado',
                                formulario: formulario.id
                            });

                            location.href = x.url;
                        }

                        return x.text();
                    })
                    .then(text => (new DOMParser()).parseFromString(text, 'text/html'))
                    .then(dom => {
                        const f = dom.querySelector<HTMLFormElement>(`#${formulario.getAttribute('id')!}`);
                        if (f) {
                            debugger;
                            formulario.parentElement!.replaceChild(f, formulario);
                            inicializaFormulario(f, opciones);

                            window.scrollTo(0, formulario.getBoundingClientRect().top + scrollY - offset());
                            f.classList.add('enviado');

                            if (!f.querySelector('input')) {
                                enviado(f);

                                dataLayer?.push({
                                    event: 'formulario-enviado',
                                    formulario: f.id
                                });
                            }
                        }
                    })
                    .finally(() => submit.disabled = false);
            });
        });
    },
    actualizaVisibilidad = (campos: HashDeCampos, formulario: HTMLFormElement) => () => {
        const datos = new FormData(formulario),
            nombre = formulario.getAttribute('data-nombre')!;

        Object.values(campos).forEach(campo => {
            const erroneos = Object.keys(campo.visibilidad).filter(key => {
                return campo.visibilidad[key] !== datos.get(`${nombre}[${key}]`);
            });

            if (erroneos.length === 0) {
                campo.input.required = campo.obligatorio;
                campo.input.parentElement!.style.display = '';
            } else {
                campo.input.required = false;
                campo.input.parentElement!.style.display = 'none';
            }
        });
    },
    configuraVisibilidad = (campos: HashDeCampos, formulario: HTMLFormElement) => {
        const actualizador = actualizaVisibilidad(campos, formulario);
        formulario.addEventListener('change', actualizador);
        actualizador();
    },
    ajustaObligatorios = (campos: HashDeCampos, formulario: HTMLFormElement) => {
        const nombreBase = formulario.getAttribute('data-nombre')!
        formulario.addEventListener('change', () => {
            Object.keys(campos).forEach(key => {
                const {input, etiqueta} = campos[key],
                    condiciones = JSON.parse(input.getAttribute('data-required') || '{}');

                if (Object.keys(condiciones).length > 0) {
                    const obligatorio = Object.keys(condiciones).reduce((valido, claveDelOtro) => {
                        const otro = document.getElementById(`${nombreBase}-${claveDelOtro}`) as HTMLInputElement;
                        return valido && (!otro || otro.value === condiciones[claveDelOtro]);
                    }, true);

                    input.required = obligatorio;

                    if (obligatorio && etiqueta.textContent!.indexOf('*') === -1) {
                        etiqueta.textContent += ' *';
                    } else if (!obligatorio && etiqueta.textContent!.indexOf('*') !== -1) {
                        etiqueta.textContent = etiqueta.textContent!.replace(' *', '');
                    }
                }
            });

        }, true);
    },
    configuraArchivos = (campos: HashDeCampos) => {
        Object.keys(campos)
            .filter(clave => campos[clave].input.type === 'file')
            .map(x => campos[x])
            .forEach(archivo => {
                const {input, etiqueta} = archivo,
                    campo = input.closest('.campo') as HTMLDivElement;

                if (campo) {
                    const texto = document.createElement('div');
                    texto.innerHTML = '&nbsp;';

                    campo.appendChild(texto);
                    campo.addEventListener('drop', ev => {
                        ev.preventDefault();

                        if (ev.dataTransfer?.files) {
                            input.files = ev.dataTransfer.files;
                            campo.classList.add('con-archivo');
                            texto.textContent = input.files[0].name;
                            etiqueta.classList.remove('is-inactiva');
                        }
                    });

                    campo.addEventListener('dragover', e => {
                        campo.classList.add('archivo-encima');
                        e.preventDefault();
                    });

                    campo.addEventListener('dragleave', e => {
                        campo.classList.remove('archivo-encima');
                    });

                    input.addEventListener('change', e => {
                        etiqueta.classList.remove('is-inactiva');
                        const nombre = input.value.split('\\').pop();

                        if (nombre) {
                            texto.textContent = nombre;
                        }
                    })
                }
            });
    }

const inicializaFormulario = (formulario: HTMLFormElement, opciones: OpcionesFormulario) => {
    if (!formulario || formulario.classList.contains('inicializado')) {
        return;
    }

    formulario.classList.add('inicializado');

    const todosLosCampos = buscaCampos(formulario);
    if (opciones.ocultarEtiquetas) {
        configuraEtiquetas(formulario);
    }

    configuraSubmit(formulario, opciones);
    configuraArchivos(todosLosCampos);
    configuraVisibilidad(todosLosCampos, formulario);
    ajustaObligatorios(todosLosCampos, formulario);
    reinicia(todosLosCampos);

    opciones.onInicializado?.(formulario);
};

interface OpcionesFormulario {
    dataLayer?: IDataLayer | undefined;
    offset?: () => number;
    ocultarEtiquetas?: boolean;
    onInicializado?: (formulario: HTMLFormElement) => void;
    enviado?: (formulario: HTMLFormElement) => void;
}

export default function formulario(
    selector: string,
    opciones: OpcionesFormulario
) {
    opciones = {
        offset: () => 0,
        ocultarEtiquetas: true,
        ...opciones,
    };

    [].forEach.call(document.querySelectorAll<HTMLFormElement>(selector), (formulario: HTMLFormElement) => {
        inicializaFormulario(formulario.closest('form') as HTMLFormElement, opciones);
    });
}